import { EAuthError, ERole } from 'auth';
import { IConsultant } from 'models';
import { IIdToken } from 'models/token';

export interface IState {
	isAuthenticated: boolean;
	error: EAuthError | null;
	salesRep: IConsultant | null;
	roles: ERole[];
	idToken: IIdToken | null;
}

export const initialState: IState = {
	isAuthenticated: false,
	error: null,
	salesRep: null,
	roles: [],
	idToken: null
};
